import { Link } from "@tanstack/react-router";
import { Mail, MessageCircle, Phone } from "lucide-react";
import { site } from "@/data/site";
import { trackConversion } from "@/lib/track";

const defaultText = [
  "Vraag vandaag nog uw vrijblijvende offerte op maat aan!",
  "Heeft u vragen over uw verhuizing, transport of planning? Neem eenvoudig contact met ons op of bel met onze klantenservice. Wij staan 7 dagen per week voor u klaar en reageren snel.",
  "Onze medewerkers denken met u mee en helpen u stap voor stap. Van de voorbereiding en de juiste verhuisservice tot een efficiënte planning en uitvoering: samen zorgen we ervoor dat uw verhuizing soepel en zonder onnodige zorgen verloopt.",
];

export function CtaBand({
  title = "Klaar om uw verhuizing te laten regelen?",
  text,
}: {
  title?: string;
  text?: string;
}) {
  const paragraphs = text ? [text] : defaultText;

  return (
    <section className="bg-secondary py-14 text-secondary-foreground">
      <div className="container-page flex flex-col items-start gap-6 lg:flex-row lg:items-center lg:justify-between">
        <div className="max-w-2xl">
          <h2 className="text-2xl font-extrabold sm:text-3xl">{title}</h2>
          {paragraphs.map((paragraph) => (
            <p key={paragraph} className="mt-3 opacity-85">
              {paragraph}
            </p>
          ))}
          <p className="mt-4 font-bold text-brand">Waarom moeilijk doen als het vakkundig kan?</p>
        </div>
        <div className="flex flex-wrap gap-3">
          <Link
            to="/offerte"
            className="rounded-md bg-brand px-5 py-3 font-bold text-brand-foreground transition hover:bg-brand-dark"
          >
            Offerte aanvragen
          </Link>
          <a
            href={site.whatsappMessage}
      onClick={() => trackConversion("whatsapp_klik")}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-md border border-background/25 px-5 py-3 font-bold transition hover:border-brand hover:text-brand"
          >
            <MessageCircle className="size-4" aria-hidden />
            WhatsApp
          </a>
          <a
            href={site.phoneHref}
      onClick={() => trackConversion("telefoon_klik")}
            className="inline-flex items-center gap-2 rounded-md border border-background/25 px-5 py-3 font-bold transition hover:border-brand hover:text-brand"
          >
            <Phone className="size-4" aria-hidden />
            {site.phone}
          </a>
          <a
            href={site.emailHref}
            className="inline-flex items-center gap-2 rounded-md border border-background/25 px-5 py-3 font-bold transition hover:border-brand hover:text-brand"
          >
            <Mail className="size-4" aria-hidden />
            E-mail ons
          </a>
        </div>
      </div>
    </section>
  );
}
